import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const SalesManager = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  return (
    <TextInput
      label={fieldData.role === 'SALES_REP' ? 'Sales Manager *' : 'Manager *'}
      value={fieldData.salesManager}
      error={
        'salesManager' in formErrors ? formErrors.salesManager.message : undefined
      }
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            salesManager: { message: 'Field is required' }
          });
        else {
          const errors = { ...formErrors };
          delete errors.salesManager;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          salesManager: value
        }));
      }}
    />
  );
};

SalesManager.propTypes = {
  formErrors: PropTypes.shape({
    salesManager: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default SalesManager;
